// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Iv1_","newExpiryDate":"styles_newExpiryDate__1-1CD","footer":"styles_footer__33NY2"};